import {ProductContext} from './~context'

export const ProductProvider = ProductContext.Provider